import { Crown, UserPlus, Users } from "lucide-react";
import React from "react";
import { notify } from "../../lib/notify";
import { useAppStore } from "../../store/useAppStore";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { PageHeader } from "../ui/page-header";

export function TeamView() {
  const { user } = useAppStore();

  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Workspace"
        title="Team"
        description="Manage your team members and their permissions"
        actions={
        <Button onClick={() => notify.info("Coming soon", { description: "Team invitations will be available in a future release." })}>
          <UserPlus className="mr-2 h-4 w-4" />
          Invite Member
        </Button>
        }
      />

      <div className="grid gap-4">
        {user && (
          <Card>
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center mr-3">
                    <Users className="h-5 w-5" />
                  </div>
                  <div>
                    <p className="font-medium">{user.name}</p>
                    <p className="text-sm text-muted-foreground">
                      {user.email}
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <Crown className="h-4 w-4 text-warning" />
                  <span className="text-sm font-medium">Owner</span>
                </div>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Full access to all projects and settings
              </p>
            </CardContent>
          </Card>
        )}

        <Card>
          <CardContent className="flex items-center justify-center py-12">
            <div className="text-center">
              <Users className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
              <h3 className="text-h4 mb-2">
                No team members yet
              </h3>
              <p className="text-muted-foreground mb-4">
                Invite team members to collaborate on your projects
              </p>
              <Button onClick={() => notify.info("Coming soon", { description: "Team invitations will be available in a future release." })}>
                <UserPlus className="mr-2 h-4 w-4" />
                Invite your first team member
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
